<script lang="ts" setup>
import { OrderStopType } from "@/data/order";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    type: OrderStopType;
    size?: number | string;
    isReload?: boolean;
    isDeleted?: boolean;
    disabled?: boolean;
  }>(),
  {
    size: 20,
    default: false,
  },
);

const stopTypeIcon = computed(() => {
  switch (props.type) {
    case OrderStopType.pickup:
      return "mdi-package-variant-closed";
    case OrderStopType.delivery:
      return "mdi-map-marker-radius-outline";
    case OrderStopType.reload:
      return "mdi-truck-refresh";
    default:
      return "";
  }
});

const stopTypeIconColor = computed(() => {
  if (props.isDeleted || props.disabled) {
    return "grey";
  }

  if (props.isReload) {
    return "orange";
  }

  switch (props.type) {
    case OrderStopType.pickup:
      return "success";
    case OrderStopType.delivery:
      return "error";
    case OrderStopType.reload:
      return "warning";
    default:
      return "";
  }
});
</script>

<template>
  <v-icon :color="stopTypeIconColor" :icon="stopTypeIcon" :size="size"></v-icon>
</template>
